<ng-template #secModal>
    <div class="modal-header">
        <h2 class="modal-title m-0">{{ dialogTitle }}</h2>
        <button type="button" class="btn-close" aria-label="Close" (click)="modalRef?.close()">
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-auto">
                <ng-scrollbar class="ngr-scrollbar" visibility="hover" track="vertical">

                    <form (submit)="searchDocument($event)">
                        <input [(ngModel)]="searchText" type="text" class="form-control search-box" placeholder="Search..." [ngModelOptions]="{standalone: true}">
                        <div class="input-group mb-3">
                            @if (inSearchMode) {
                            <input [value]="searchProgress" type="text" class="form-control border-bd-green-colour" disabled>
                            <button class="btn btn-bankruptcydata" type="button"><i-bs [name]="iconNames.ChevronUp" (click)="gotoMark(-1)"></i-bs></button>
                            <button class="btn btn-bankruptcydata" type="button"><i-bs [name]="iconNames.ChevronDown" (click)="gotoMark(+1)"></i-bs></button>
                            <button class="btn btn-bankruptcydata" type="submit"><i-bs [name]="iconNames.X" (click)="resetSearch()"></i-bs></button>
                            } @else {
                            @if (searchLoading) {
                            <button class="btn btn-bankruptcydata w-100" type="submit" disabled>
                                <div class="spinner-border spinner-border-sm"></div>
                            </button>
                            } @else {
                            <button class="btn btn-bankruptcydata w-100" type="submit">Search</button>
                            }
                            }
                        </div>
                    </form>
                    @if (tableOfContents.length > 0) {
                    <h5 class="column-header text-uppercase fs-6">Table of Contents</h5>
                    <table class="toc">
                        @for (toc of tableOfContents; track toc) {
                        <tr>
                            @if (toc.text?.length > 0) {
                            <td>
                                @if (toc.label?.length > 0 && !toc.text.includes(toc.label)) {
                                {{toc.label}}
                                }
                            </td>
                            <td (click)="scrollToAnchor(toc.anchor)" [innerHTML]="toc.text" [ngbTooltip]="toc.text">
                            </td>
                            } @else {
                            <td colspan="2" (click)="scrollToAnchor(toc.anchor)">
                                {{toc.label}}
                            </td>
                            }
                        </tr>
                        }
                    </table>
                    }
                    @if (exhibits.length > 0) {
                    <h5 class="column-header text-uppercase fs-6">Exhibits</h5>
                    <table class="toc">
                        @for (exhibit of exhibits; track exhibit.id) {
                        @if (exhibit.type == 'EXCEL') {
                        <tr (click)="downloadDocument(currentForm!, exhibit.id)">
                            <td><i-bs [name]="iconNames.FileExcel"></i-bs></td>
                            <td [innerHTML]="exhibit.file ?? 'Download'"></td>
                        </tr>
                        } @else {
                        @if (exhibit.type.includes('EX-')) {
                        <tr (click)="loadDocumentIntoDialog(currentForm!.formid, exhibit.id, false, true)" [ngbTooltip]="exhibit.tooltip">
                            <td>{{exhibit.type.replace('EX-', '')}}</td>
                            <td>{{exhibit.type}}</td>
                        </tr>
                        } @else {
                        <tr (click)="loadDocumentIntoDialog(currentForm!.formid, exhibit.id, false, true)">
                            <td></td>
                            <td>{{exhibit.type}}</td>
                        </tr>

                        }
                        }
                        }
                    </table>
                    }
                </ng-scrollbar>
            </div>
            <div #document class="col">
                <ng-scrollbar #secdocument="ngScrollbar" class="ngr-scrollbar document-viewer" visibility="hover" track="vertical" [innerHTML]="htmlContent | safe: 'html'">
                </ng-scrollbar>
            </div>
        </div>
    </div>
</ng-template>
<iframe class="d-none" [src]="exportDownloadURL | safe: 'resourceUrl'"></iframe>
<adobe-pdf-viewer></adobe-pdf-viewer>